import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {FormGroup, Input, Label} from "reactstrap"
import {filterMex} from "../../helpers/skuFilter"

class FilterMex extends Component {
    _handleChangeStatus = (e) => {
        const {name, value} = e.target
        const {onChangeFilter} = this.props

        if (typeof onChangeFilter === 'function') {
            const booleanValue = value === '' ? '' : value === 'true'
            onChangeFilter(name, booleanValue)
        }
    }

    render() {
        const {mex} = this.props

        return (
            <div className="FilterMex">
                <FormGroup>
                    <Label className='font-weight-bold'>Ép mex</Label>
                    <Input type='select' value={mex} name='mex' onChange={this._handleChangeStatus}>
                        {
                            filterMex.map(item => {
                                return <option key={item.value} value={item.value}>{item.name}</option>
                            })
                        }
                    </Input>
                </FormGroup>
            </div>
        )
    }
}

FilterMex.propTypes = {
    procedure: PropTypes.any,
    onChangeFilter: PropTypes.func
}

export default FilterMex